import * as React from "react";
import Layout from "./layout";
import Hero from "./hero";
import Services from "./services";
import Products from "./products";
import Events from "./events";
import Map from "../map-component";
import Contact from "./contact";
import Search from "../product-search";
export default class View extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement(Layout, Object.assign({}, this.props),
            React.createElement(Hero, Object.assign({}, this.props)),
            React.createElement(Services, Object.assign({}, this.props)),
            React.createElement(Products, Object.assign({}, this.props)),
            React.createElement(Search, Object.assign({}, this.props, { buttonClass: "btn-template-a" })),
            React.createElement(Events, Object.assign({}, this.props)),
            React.createElement(Contact, { supplier: this.props.supplier }),
            React.createElement(Map, { location: { lat: this.props.supplier.Latitude, lng: this.props.supplier.Longitude } })));
    }
}
;
//# sourceMappingURL=view.js.map